import { fromEvent } from 'rxjs';
import { startWith, throttleTime } from 'rxjs/operators';

export function setupDynamicViewportHeightFallbackUnitCalculator() {
  if (window.CSS && CSS.supports('color', 'var(--fake-var)')) {
    fromEvent(window, 'resize')
      .pipe(throttleTime(50), startWith(null))
      .subscribe(() => {
        const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) * 0.01;
        document.documentElement.style.setProperty('--kgr-one-dvh-calculated', `${vh}px`);
      });
  }
}
